import React, { useState } from 'react'
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

const YearOfArchive = () => {
      //---------------- counting animation ------------
  const [counterOn, setCounterOn] = useState(false);

  const handleHover = () => {
    if (!counterOn) {
      setCounterOn(true);
    }
  };
  return (
    <div >
       <section >
        <ScrollTrigger
          // onEnter={() => setCounterOn(true)}
          // onExit={() => setCounterOn(false)}
          onEnter={handleHover}
          onExit={() => {}}
        >
          <div className="flex w-full h-auto lg:h-40 xl:h-52 py-3  md:h-28 bg-gradient-to-r from-black via-fuchsia-600 to-black items-center text-center">
            <div className="grid grid-cols-4 xl:gap-16 gap-3 md:gap-10 mx-auto text-white  ">
              <div>
                <h2 className="xl:text-7xl lg:text-4xl md:text-3xl text-[10px] font-bold text-white/50">
                  {counterOn && (
                    <CountUp start={0} end={99} duration={2} delay={0} />
                  )}
                  %
                </h2>
                <p className="xl:text-2xl text-[5px] md:text-lg">
                  Client Retention
                </p>{" "}
              </div>
              <div>
                {" "}
                <h2 className="xl:text-7xl lg:text-4xl md:text-3xl text-[10px] font-bold text-white/50">
                  {counterOn && (
                    <CountUp start={0} end={5} duration={2} delay={0} />
                  )}
                  +
                </h2>{" "}
                <p className="xl:text-2xl text-[5px] md:text-lg">
                  Years of Services
                </p>
              </div>
              <div>
                <h2 className="xl:text-7xl  lg:text-4xl md:text-3xl text-[10px] font-bold text-white/50">
                  {counterOn && (
                    <CountUp start={0} end={3} duration={2} delay={0} />
                  )}
                  +
                </h2>{" "}
                <p className="xl:text-2xl text-[5px] md:text-lg">
                  Professionals
                </p>{" "}
              </div>
              <div>
                <h2 className="xl:text-7xl  lg:text-4xl md:text-3xl text-[10px] font-bold text-white/50">
                  {counterOn && (
                    <CountUp start={0} end={6} duration={2} delay={0} />
                  )}
                  +
                </h2>{" "}
                <p className="xl:text-2xl text-[5px] md:text-lg">
                  Happy Clients
                </p>{" "}
              </div>
            </div>
          </div>
        </ScrollTrigger>
      </section>
    </div>
  )
}

export default YearOfArchive
